async function saveDeviceToken(token, urls, Network) {
  let isClient = false
  try {
    if (window) isClient = true
  } catch (error) {
    console.log(error)
  }
  if (!isClient) return
  const url = urls.saveDeviceToken
  const response = await sendRequest(token, url, Network)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(token, url, Network) {
  const userReference = await self.servicesVars.getUserReference()

  const body = {
    userId: userReference,
    channel: /socket/i.test(token) ? 'socket' : 'fcm',
    recipientId: token,
  }

  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response, Formatter) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    return {
      success: true,
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { saveDeviceToken }
